module.exports = __webpack_public_path__ + "static/media/accept.ed32313f.svg";